import Vue from 'vue'

// import d2Container from './d2-container'
// import d2ContainerFrame from './d2-container-frame'
// import d2LinkBtn from './d2-link-btn'
// [ 可选插件组件 ] 网格布局组件
// import { GridLayout, GridItem } from 'vue-grid-layout'
// [ 可选插件组件 ] 区域划分组件
// import SplitPane from 'vue-splitpane'
// [ 可选组件 ] UEditor
import VueUeditorWrap from 'vue-ueditor-wrap'
// |- lib/
// |- line.common.js  -------------- 折线图
// |- bar.common.js  --------------- 条形图
// |- histogram.common.js  --------- 柱状图
// |- pie.common.js  --------------- 饼图
// |- ring.common.js  -------------- 环图
// |- funnel.common.js  ------------ 漏斗图
// |- waterfall.common.js  --------- 瀑布图
// |- radar.common.js  ------------- 雷达图
// |- map.common.js  --------------- 地图
// |- sankey.common.js  ------------ 桑基图
// |- heatmap.common.js  ----------- 热力图
// |- scatter.common.js  ----------- 散点图
// |- candle.common.js  ------------ k线图
// |- gauge.common.js  ------------- 仪表盘
// |- tree.common.js  -------------- 树图
// |- bmap.common.js  -------------- 百度地图
// |- amap.common.js  -------------- 高德地图
import VeLine from 'v-charts/lib/line.common'
import Vehistogram from 'v-charts/lib/histogram.common'
import Vepie from 'v-charts/lib/pie.common'
import VeRing from 'v-charts/lib/ring.common'
import tableFixedRightTemplate from "@/components/tableFixedRightTemplate/tableFixedRightTemplate.vue";
import loading from "@/components/loading/loading.vue";

// 注意 有些组件使用异步加载会有影响
// Vue.component('d2-container', d2Container)
// Vue.component('d2-page-cover', () => import('./d2-page-cover/index.vue'))
// Vue.component('d2-icon', () => import('./d2-icon/index.vue'))
// Vue.component('d2-icon-svg', () => import('./d2-icon-svg/index.vue'))
// Vue.component('ui-cert-list', () => import('./ui-certList/index.vue'))

// Vue.component('d2-container', d2Container)
// Vue.component('d2-container-frame', d2ContainerFrame)
// Vue.component('d2-link-btn', d2LinkBtn)
// Vue.component('d2-page-cover', () => import('./d2-page-cover'))
// Vue.component('d2-count-up', () => import('./d2-count-up'))
// Vue.component('d2-highlight', () => import('./d2-highlight'))
// Vue.component('d2-icon', () => import('./d2-icon'))
// Vue.component('d2-icon-svg', () => import('./d2-icon-svg/index.vue'))
// Vue.component('d2-icon-select', () => import('./d2-icon-select/index.vue'))
// Vue.component('d2-icon-svg-select', () => import('./d2-icon-svg-select/index.vue'))
// Vue.component('d2-markdown', () => import('./d2-markdown'))
// Vue.component('d2-mde', () => import('./d2-mde'))
// Vue.component('d2-module-index-banner', () => import('./d2-module-index-banner'))
// Vue.component('d2-module-index-menu', () => import('./d2-module-index-menu'))
// Vue.component('d2-quill', () => import('./d2-quill'))
// Vue.component('d2-ueditor', () => import('./d2-ueditor'))

// Vue.component('img-dialog', () => import('./img-dialog'))

//详情页面
// Vue.component('detail', () => import('./detail'))
// 可选插件
// Vue.component('d2-grid-layout', GridLayout)
// Vue.component('d2-grid-item', GridItem)
// Vue.component('SplitPane', SplitPane)
Vue.component('VueUeditorWrap', VueUeditorWrap)
Vue.component(VeLine.name, VeLine)
Vue.component(Vehistogram.name,Vehistogram)
Vue.component(Vepie.name, Vepie)
Vue.component(VeRing.name, VeRing)

Vue.component('table-fixed-right-template', tableFixedRightTemplate)
Vue.component('loading', loading)
